export enum TextNature {
  positive = "positive",
  negative = "negative",
  neutral = "neutral",
  info = "info",
  warning = "warning",
  light = "light",
  subtle = "subtle",
}
